module.exports = __webpack_public_path__ + "static/media/investbanner@3x.8966c2a1.png";